import styled from '@emotion/styled';
import { Button } from '@pairy/pds-react';

export const ArrowButton = styled(Button)`
  width: auto;
  height: auto;

  &.disable {
    cursor: initial;
    opacity: 0.25;
  }

  transition: opacity 0.15s ease-in-out;
`;
